export default "__VITE_ASSET__CxW4R_ZI__"